<div class="ignite-body">
  <div [class.hidden]="(showMenu$ | async) === false">
    <ignite-toolbar [firstName]="currentUserFirstName" [lastName]="currentUserLastName" [profileOptions]="profileOptions"></ignite-toolbar>
    <ignite-menu>
      <ignite-menu-button label="Dashboard" link="dashboard"></ignite-menu-button>
      <ignite-menu-button label="Form" link="formfields"></ignite-menu-button>
      <ignite-menu-button label="Controls" link="controls"></ignite-menu-button>
      <ignite-menu-button label="Grid" link="grid" badgeText="New"></ignite-menu-button>
      <ignite-menu-button label="Solo Card" link="solo-card"></ignite-menu-button>
    </ignite-menu>
  </div>
  <div class="ignite-main-content-container" cdkScrollable>
    <div class="ignite-main-content">
      <router-outlet></router-outlet>
    </div>
    <ignite-footer></ignite-footer>
  </div>
</div>
